import styled, { createGlobalStyle } from 'styled-components';

/** Scales value font to card width and character count — bold max ~38px, shrinks for long numbers. */
const KPI_VALUE_FONT_BY_TIER = {
  lg: 'clamp(1.125rem, calc(100cqw / (var(--kpi-value-chars, 6) * 0.46)), 2.375rem)',
  md: 'clamp(1rem, calc(100cqw / (var(--kpi-value-chars, 8) * 0.48)), 2.125rem)',
  sm: 'clamp(0.9375rem, calc(100cqw / (var(--kpi-value-chars, 10) * 0.5)), 2rem)',
  xs: 'clamp(0.875rem, calc(100cqw / (var(--kpi-value-chars, 12) * 0.52)), 1.75rem)',
  xxs: 'clamp(0.8125rem, calc(100cqw / (var(--kpi-value-chars, 14) * 0.54)), 1.625rem)',
};

export const KpiRow = styled.div`
  align-items: stretch;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 24px;
  overflow: visible;
  width: 100%;

  @media (min-width: 1100px) {
    gap: 10px;
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;

export const KpiCell = styled.div`
  align-items: stretch;
  container-name: live-dashboard-kpi-cell;
  container-type: inline-size;
  display: flex;
  height: auto;
  min-height: 70px;
  min-width: 0;
  overflow: visible;
  width: 100%;
`;

export const ChartCell = styled.div`
  min-height: 420px;
  width: 100%;
`;

export const LiveDashboardBoardStyles = createGlobalStyle`
  .live-dashboard-board [id^='kpi-'] {
    display: flex;
    height: auto;
    min-width: 0;
    overflow: visible;
    width: 100%;
  }

  .live-dashboard-board [id^='kpi-'] > .highcharts-dashboards-component {
    flex: 1;
    height: auto;
    margin: 0 !important;
    width: 100%;
  }

  .live-dashboard-board .highcharts-dashboards-component-kpi.live-dashboard-kpi-component {
    background: #2251FF !important;
    border: 1px solid #2251FF !important;
    border-radius: 4px !important;
    box-shadow: none !important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    forced-color-adjust: none;
    height: auto;
    min-height: 70px;
    overflow: visible;
    text-align: center;
    width: 100%;
    font-size: 25px !important;
    font-family: 'McKinsey Sans Medium', 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif;
    font-weight: 700 !important;
    color: #ffffff !important;
  }

  .live-dashboard-board .highcharts-dashboards-component-kpi .highcharts-dashboards-component-title {
    align-items: center;
    color: #ffffff !important;
    display: flex;
    forced-color-adjust: none;
    flex: 0 0 auto;
    font-family: 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif;
    font-size: 15px !important;
    font-weight: 400 !important;
    height: calc(16px * 1.35 * 2);
    justify-content: center;
    line-height: 1.35 !important;
    margin: 0 !important;
    max-width: 100%;
    min-height: calc(16px * 1.35 * 2);
    overflow: hidden;
    overflow-wrap: anywhere;
    padding: 0 2px !important;
    text-align: center !important;
    white-space: normal;
    width: 100%;
  }

  .live-dashboard-board .highcharts-dashboards-component-kpi .highcharts-dashboards-component-content,
  .live-dashboard-board .highcharts-dashboards-component-kpi .highcharts-dashboards-component-kpi-content {
    align-items: center;
    display: flex !important;
    flex: 1 1 auto;
    flex-direction: column;
    height: auto !important;
    justify-content: center;
    min-height: 0;
    min-width: 0;
    overflow: visible;
    padding: 0 !important;
    width: 100%;
    color: #ffffff !important;
  }

  .live-dashboard-board .highcharts-dashboards-component-kpi .highcharts-dashboards-component-kpi-value {
    color: #ffffff !important;
    display: block;
    flex: 0 0 auto;
    forced-color-adjust: none;
    font-family: 'McKinsey Sans Medium', 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif;
    font-size: 25px !important;
    font-variant-numeric: tabular-nums;
    font-weight: 700 !important;
    line-height: 1.1 !important;
    margin: 0 !important;
    max-width: 100%;
    overflow: visible;
    text-align: center !important;
    white-space: nowrap;
    width: 100%;
  }

  .live-dashboard-board .live-dashboard-kpi-tier-lg .highcharts-dashboards-component-kpi-value {
    font-size: ${KPI_VALUE_FONT_BY_TIER.lg} !important;
  }

  .live-dashboard-board .live-dashboard-kpi-tier-md .highcharts-dashboards-component-kpi-value {
    font-size: ${KPI_VALUE_FONT_BY_TIER.md} !important;
  }

  .live-dashboard-board .live-dashboard-kpi-tier-sm .highcharts-dashboards-component-kpi-value {
    font-size: ${KPI_VALUE_FONT_BY_TIER.sm} !important;
  }

  .live-dashboard-board .live-dashboard-kpi-tier-xs .highcharts-dashboards-component-kpi-value {
    font-size: ${KPI_VALUE_FONT_BY_TIER.xs} !important;
  }

  .live-dashboard-board .live-dashboard-kpi-tier-xxs .highcharts-dashboards-component-kpi-value {
    font-size: ${KPI_VALUE_FONT_BY_TIER.xxs} !important;
  }

  .live-dashboard-board .live-dashboard-kpi-long-title .highcharts-dashboards-component-title {
    font-size: 15px !important;
    height: calc(16px * 1.35 * 2);
    min-height: calc(16px * 1.35 * 2);
  }

  .live-dashboard-board .highcharts-dashboards-component-kpi .highcharts-dashboards-component-kpi-subtitle {
    display: none;
  }

  .live-dashboard-board .live-dashboard-chart-cell > .highcharts-dashboards-component {
    margin: 0 !important;
    width: 100%;
  }

  .live-dashboard-board .live-dashboard-chart-cell .highcharts-dashboards-component-content {
    padding: 0;
  }
`;
